<template>
  <survey-base :id="String(id)" category="事前登録" routerName="Survey" />
</template>

<script>
import SurveyBase from "@/components/SurveyBase";
export default {
  components: {
    SurveyBase
  },
  props: ["id"]
};
</script>
